import React, { useCallback, useState } from "react";

const GameCtx = React.createContext({
	currentGameSlug: null,
	currentFaction: null,
	onCurrentGameChange: (game) => { },
	onCurrentFactionChange: (game, faction) => { },
});


export function GameCtxProvider(props) {
	const [currentGameSlug, setCurrentGame] = useState(null);
	const [currentFaction, setCurrentFaction] = useState(null);

	const handleCurrentGameChange = useCallback((game) => {
		setCurrentGame(game);
		setCurrentFaction(null);
	}, []);

	const handleCurrentFactionChange = useCallback((game, faction) => {
		if (!faction) {
			setCurrentFaction(null);
		} else if (game.slug !== currentGameSlug?.slug) {
			setCurrentGame(game);
			setCurrentFaction(faction);
		} else {
			setCurrentFaction(faction);
		}
	}, [currentGameSlug?.slug]);

	return (
		<GameCtx.Provider
			value={{
				currentGameSlug,
				currentFaction,
				onCurrentGameChange: handleCurrentGameChange,
				onCurrentFactionChange: handleCurrentFactionChange,
			}}
		>
			{props.children}
		</GameCtx.Provider>
	);
}

export default GameCtx;